import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IAdHocOutgoingInvoiceCreateRouteParams {
    reservationId: Guid
}

interface IAdHocOutgoingInvoiceCreateRouteQuery {
    backUrl: string
}

const AdHocOutgoingInvoiceCreateRoute = new AppRoute<IAdHocOutgoingInvoiceCreateRouteParams, IAdHocOutgoingInvoiceCreateRouteQuery>({
    route: "/outgoing-invoice/:reservationId/ad-hoc",
    navbar: true,
    authRequired: true,
})

export default AdHocOutgoingInvoiceCreateRoute
